import axios from 'axios'
import { Message, Loading } from 'element-ui'
import { API_BASE_URL } from './config'

export function isSuccessCode(code) {
  return code === 1 || code === 0 || code === 200
}

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' }
})

service.interceptors.response.use(
  (response) => {
    const body = response.data
    if (body && typeof body === 'object' && 'code' in body) {
      if (isSuccessCode(body.code)) {
        return body.data !== undefined ? body.data : body
      }
      return Promise.reject(body)
    }
    return body
  },
  (error) => Promise.reject(error)
)

let loadingInstance = null
let loadingCount = 0

function showLoading(text) {
  if (loadingCount === 0) {
    loadingInstance = Loading.service({
      lock: true,
      text: text || '加载中...',
      background: 'rgba(0, 0, 0, 0.3)'
    })
  }
  loadingCount++
}

function hideLoading() {
  loadingCount--
  if (loadingCount <= 0) {
    loadingCount = 0
    if (loadingInstance) {
      loadingInstance.close()
      loadingInstance = null
    }
  }
}

export function request(options = {}) {
  const {
    url,
    method = 'GET',
    data,
    params,
    showLoading: needLoading = false,
    loadingText = '加载中...',
    silent = false,
    ...rest
  } = options

  if (needLoading) showLoading(loadingText)

  const promise = service.request({
    url,
    method,
    data,
    params,
    ...rest
  })

  return promise
    .catch((err) => {
      if (!silent) {
        const msg = err.msg || err.message || (err.response ? '网络异常' : '网络请求失败')
        Message.error(msg)
      }
      return Promise.reject(err)
    })
    .finally(() => {
      if (needLoading) hideLoading()
    })
}

export function get(url, params, options = {}) {
  return request({ url, method: 'GET', params, ...options })
}

export function post(url, data, options = {}) {
  return request({ url, method: 'POST', data, ...options })
}

export function upload(file) {
  const formData = new FormData()
  formData.append('file', file)
  return service.post('/api/common/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then((data) => {
    const url = typeof data === 'string'
      ? data
      : (data && (data.url || data.fullurl || data.path)) || data
    return url
  }).catch((err) => {
    const msg = err.msg || err.message || '上传失败'
    Message.error(msg)
    return Promise.reject(err)
  })
}
